import { Button, Card, CardContent, Chip, CircularProgress, Divider, Grid, List, ListItem, ListItemText, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { DateFormatter } from '../../../Component/Model/helpers';
import { LatestNewsCategories } from './Home';

import NewspaperIcon from '@mui/icons-material/Newspaper';
import ForumIcon from '@mui/icons-material/Forum';
import SchoolIcon from '@mui/icons-material/School';
import InfoIcon from '@mui/icons-material/Info';
import { HomeUpdatesDto } from '../../../Component/Model/Dto/Home/Home';
import { HomeService } from '../../../Component/Api/Home/HomeService';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { UpdatesModal } from './UpdatesModal';
import { defaultObject } from '../../../Helpers/typescriptHelper';
import { Link } from 'react-router-dom';
import colors from '../../../assets/theme/base/colors';

const { dark, primary } = colors;

export const ClientHomeUpdates = () => {

    const [newsData, setNewsData] = React.useState<HomeUpdatesDto.Response[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const [showModal, setShowModal] = React.useState(false);
    const [modalData, setModalData] = React.useState<HomeUpdatesDto.Response>(defaultObject);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let response = await HomeService.getHomeUpdates();
            setNewsData(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    const getCategoryChip = (category: LatestNewsCategories) => {

        let label = "";
        let toComponentUrl =""
        let icon = <></>;
        let color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | undefined = "primary";

        switch (category) {
            case LatestNewsCategories.News:
                icon = <NewspaperIcon />
                label = "News";
                color = "primary";
                toComponentUrl = "/news";
                break;
            case LatestNewsCategories.Forum:
                icon = <ForumIcon />
                label = "Forum";
                color = "secondary";
                toComponentUrl = "beeForum";
                break;
            case LatestNewsCategories.Learning:
                icon = <SchoolIcon />
                label = "Learning";
                color = "success";
                toComponentUrl = "/academy/digitalContent";
                break;
            case LatestNewsCategories.Updates:
                icon = <InfoIcon />
                label = "Updates";
                color = "warning";
                toComponentUrl = "/whatsNew";
                break;
            default:
                break;
        }
        
        return (
            <Chip icon={icon} label={label} variant="outlined" size='small' color={color} component={Link} to={toComponentUrl} clickable/>
        )
    }

    const getActionButton = (result: HomeUpdatesDto.Response) => {
        let label = "";

        switch (result.category) {
            case LatestNewsCategories.News:
                label = "Read";
                break;
            case LatestNewsCategories.Forum:
                label = "Read";
                break;
            case LatestNewsCategories.Learning:
                label = "Attend";
                break;
            case LatestNewsCategories.Updates:
                label = "Learn More";
                break;
            default:
                break;
        }

        if(label === "Attend"){
            return (
                <Button variant="text" href={result.url} target="_blank">{label}</Button>
            )  
        }
        return (
            <Button variant="text" onClick={() => {
                setModalData(result);
                setShowModal(true);
            }}>{label}</Button>
        )

    }


    const renderNews = newsData.map((result, index) => {
        return (
            <ListItem key={`list-item-${index}`} alignItems="flex-start" sx={{ height: "40px" }}>
                <ListItemText primary={
                    <>
                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid item xs={1.5}>
                                {getCategoryChip(result.category)}
                            </Grid>
                            <Grid item xs={1.5}>
                                <Typography variant="body2" noWrap color="secondary">{DateFormatter(result.date.toString())}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" noWrap sx={{color:dark.main}}>{result.title}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                {getActionButton(result)}
                            </Grid>
                        </Grid>
                        <Divider component="li" key={`divider-key-${index}`} sx={{ margin: 0 }} />
                    </>
                } />
            </ListItem>
        );
    });

    const RenderContent = () => {
        if (isLoading) {
            return (
                <Grid container justifyContent="center" >
                    <CircularProgress />
                </Grid>
            )
        }
        else {
            if (newsData.length === 0) {
                return (
                    <MDTypography>No News to Show</MDTypography>
                )
            }
            return (
                <List>{renderNews}</List>
            )
        }
    }

    return (
        <>
            <Grid container mb={2}>
                <Grid item xs={12}>
                    <Card sx={{border : `2px solid ${primary.main}`}}>
                        <CardContent>
                            <Typography variant="h5" color="primary" mb={1}>
                                Latest Updates
                            </Typography>
                            {RenderContent()}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <UpdatesModal data={modalData} open={showModal} onClose={() => { setShowModal(false) }} />
        </>
    )
}
